<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <UporabneStraniPovezave/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import InformativneVsebine from './UporabneStrani/InformativneVsebine'
import UporabneStraniPovezave from './UporabneStrani/UporabneStraniPovezave'

export default {
  name: 'UporabneStrani',
  components: {
    InformativneVsebine,
    'IzbirnikStranke': IzbirnikStranke,
    'UporabneStraniPovezave': UporabneStraniPovezave
  }
}
</script>
<style scoped src="../../../../../static/css/UporabniskiKoticek/PogostaVprasanja.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/UporabneStrani.vue